module.exports = __webpack_public_path__ + "img/hero.b77b1adb.png";